import { render, staticRenderFns } from "./AccountProfileGeneral.vue?vue&type=template&id=0bce2b76&"
import script from "./AccountProfileGeneral.vue?vue&type=script&lang=js&"
export * from "./AccountProfileGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AccountProfileGeneral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports